/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    em: "em",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, React.createElement(_components.em, null, "Eat quickly, but don't get in trouble with your aristocratic parents!")), "\n", React.createElement(_components.p, null, "This two player arcade game was created as part of the ", React.createElement(_components.a, {
    href: "http://fantasticfest.com/arcade"
  }, "Fantastic Arcade"), " game jam, ", React.createElement(_components.a, {
    href: "http://itch.io/jam/barfcade"
  }, "Barfcade"), " in 2014! It was inspired by NES styles of play and used the color palette as well."), "\n", React.createElement(_components.p, null, "The entire game was created during an 18 hour car trip from Minneapolis to Austin, TX with me in the car coding and Brian Quarfoth remotely sending art along the way."), "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://jerrytron.itch.io/polite-dinner-extreme"
  }, React.createElement(_components.strong, null, "Download on itch.io to play!"))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
